import { Controller } from "@hotwired/stimulus"

// Яндекс.Карты v2.1 с маркером и встроенным баллуном.
// API подгружается динамически по первому connect — повторные mount'ы переиспользуют window.ymaps.
let yandexMapsPromise = null

const loadYandexMaps = (apiKey) => {
  if (yandexMapsPromise) return yandexMapsPromise

  yandexMapsPromise = new Promise((resolve, reject) => {
    if (typeof window.ymaps !== "undefined") {
      window.ymaps.ready(resolve)
      return
    }
    const script = document.createElement("script")
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${encodeURIComponent(apiKey)}&lang=ru_RU`
    script.async = true
    script.onload = () => window.ymaps.ready(resolve)
    script.onerror = reject
    document.head.appendChild(script)
  })

  return yandexMapsPromise
}

export default class extends Controller {
  static values = {
    latitude: Number,
    longitude: Number,
    zoom: Number,
    apiKey: String,
    title: String,
    address: String,
    externalUrl: String
  }

  async connect() {
    try {
      await loadYandexMaps(this.apiKeyValue)
      this.initMap()
    } catch (e) {
      console.error("Не удалось загрузить Яндекс.Карты", e)
    }
  }

  disconnect() {
    this.map?.destroy()
    this.map = null
  }

  initMap() {
    const coords = [this.latitudeValue, this.longitudeValue]

    this.map = new window.ymaps.Map(this.element, {
      center: coords,
      zoom: this.zoomValue,
      controls: ["zoomControl", "fullscreenControl"]
    }, {
      suppressMapOpenBlock: true
    })

    const balloonBody = `
      <div style="font-family: 'DM Sans', sans-serif; padding: 4px 0;">
        <div style="font-size: 13px; color: #6b7280; margin-bottom: 8px;">${this.escapeHtml(this.addressValue)}</div>
        <a href="${this.externalUrlValue}" target="_blank" rel="noopener"
           style="font-size: 12px; color: #1d3f8f; font-weight: 600; text-decoration: none;">
          Открыть в Яндекс.Картах →
        </a>
      </div>
    `

    const placemark = new window.ymaps.Placemark(coords, {
      balloonContentHeader: this.titleValue,
      balloonContentBody: balloonBody,
      hintContent: this.titleValue
    }, {
      preset: "islands#redIcon",
      iconColor: "#c49a3c"
    })

    this.map.geoObjects.add(placemark)
    placemark.balloon.open()
  }

  escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
